import { render } from "./Workplaces.vue?vue&type=template&id=1a4495d7&scoped=true"
import script from "./Workplaces.vue?vue&type=script&lang=js"
export * from "./Workplaces.vue?vue&type=script&lang=js"

import "./Workplaces.vue?vue&type=style&index=0&id=1a4495d7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a4495d7"]])

export default __exports__